import React from 'react';
import {Card, CenteredTypography, Section} from './CardStyles';
import {styled} from '@mui/material/styles';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import {Button, MobileStepper, Paper} from '@mui/material';
import {motion} from 'framer-motion';
import SwipeableViews from 'react-swipeable-views';
import {autoPlay} from 'react-swipeable-views-utils';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@mui/icons-material';

const TestimonialWrapper = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const testimonials = [
  {
    text: 'Die Widgets vereinfachen alles, man braucht nur noch auf FuPa die Einstellungen wie Kader zu bearbeiten und bekommt alle Statistiken sofort auf seine Website übermittelt!',
    author: 'Kevin Harpes',
    club: 'Blo-Wäiss Medernach',
    competition: '(Ehrenpromotion, 2. Liga Luxemburg)',
  },
  {
    text: 'Als einer der ersten in Baden nutze ich FuPa schon seit vielen Jahren. Die Widgets helfen, unsere Fans über Aktuelles, Statistiken usw. zu informieren. Ich bin wirklich sehr zufrieden, insbesondere darüber, dass die neuen Widgets jetzt auch responsiv sind.',
    author: 'Marco Nabinger',
    club: '1. CfR Pforzheim',
    competition: '(Oberliga Baden-Württemberg)',
  },
  {
    text: 'Die Widgets schaffen durch ihre Aktualität und die Möglichkeit der individuellen Gestaltung schon seit Jahren einen extremen Mehrwert für unsere Vereins-Website. Durch die neuen Widgets profitieren wir zusätzlich von noch reibungsloseren Saisonübergängen. Wir freuen uns schon auf alle weiteren Features. Klasse Arbeit, liebes FuPa-Team!',
    author: 'Dennis Jaura',
    club: 'SV Aubing',
    competition: '(Bezirksliga Oberbayern Süd)',
  },
];

const DemoPaper = styled(Paper)(({theme}) => ({
  maxWidth: 500,
  height: 'auto',
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'left',
  backgroundColor: 'rgba(255,255,255,0.2)',
  borderRadius: SIZES['4'],
}));
const TestimonialContent = styled('div')`
  display: flex;
  flex-direction: row;
`;

const StyledTypography = styled(Typography)`
  &&& {
    color: ${COLORS.lightestGrey};
  }
`;

const Author = styled(Typography)`
  &&& {
    color: ${COLORS.lightGrey};
  }
`;

const TestimonialsCard = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = testimonials.length;

  const handleNext = () => {
    if (activeStep === maxSteps - 1) {
      setActiveStep(0);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      setActiveStep(maxSteps - 1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const Testimonials = testimonials.map((testimonal, index) => {
    return (
      <DemoPaper key={index} variant='outlined'>
        <TestimonialContent>
          <FormatQuoteIcon sx={{}} color='primary' />
          <div>
            <StyledTypography variant={'subheading'} component={'p'}>
              {testimonal.text}
            </StyledTypography>
            <Author variant={'caption1'}>— {testimonal.author}</Author>
            <br />
            <Author variant={'caption2'}>
              {testimonal.club} {testimonal.competition}
            </Author>
          </div>
        </TestimonialContent>
      </DemoPaper>
    );
  });

  return (
    <Section backgroundColor={COLORS.fupaPrimary} primaryGradient>
      <Card>
        <CenteredTypography color={COLORS.white} variant='headline2' component='h2'>
          Was die Vereine sagen
        </CenteredTypography>
        <TestimonialWrapper
          initial={{y: 48}}
          whileInView={{
            y: 0,
            transition: {
              type: 'spring',
              stiffness: 100,
              damping: 30,
              restDelta: 0.001,
            },
          }}>
          <AutoPlaySwipeableViews
            style={{maxWidth: '500px', width: '100%'}}
            interval={5000}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents>
            {Testimonials}
          </AutoPlaySwipeableViews>
          <MobileStepper
            sx={{backgroundColor: 'transparent'}}
            nextButton={
              <Button size='small' onClick={handleNext}>
                <KeyboardArrowRight />
              </Button>
            }
            backButton={
              <Button size='small' onClick={handleBack}>
                <KeyboardArrowLeft />
              </Button>
            }
            steps={maxSteps}
            position='static'
            activeStep={activeStep}
          />
        </TestimonialWrapper>
      </Card>
    </Section>
  );
};

export default TestimonialsCard;
